import { useTranslation } from '@wix/yoshi-flow-editor';

export type TranslationsFn<T> = (key: T, params?: any) => string;

export const useTranslate = <T>() => {
  const { t } = useTranslation();
  return t as TranslationsFn<T>;
};
